// 言語切替のドロップダウン開閉（ディスクロージャーパターン）
class LanguageSwitcher {
  constructor(el) {
    this.dom = { el: el };
    this.dom.trigger = el.querySelector('[data-js="language-trigger"]');
    this.dom.list = el.querySelector('[data-js="language-list"]');

    if (!this.dom.trigger || !this.dom.list) return;

    this.close = this.close.bind(this);
    this.init();
  }

  init() {
    this.dom.trigger.addEventListener('click', () => {
      this.isOpen() ? this.close() : this.open();
    });

    // Esc で閉じてトリガーにフォーカスを戻す
    this.dom.el.addEventListener('keydown', e => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
        this.dom.trigger.focus();
      }
    });

    // 外側クリック・フォーカスが外れたら閉じる
    document.addEventListener('click', e => {
      if (this.isOpen() && !this.dom.el.contains(e.target)) this.close();
    });
    this.dom.el.addEventListener('focusout', e => {
      if (this.isOpen() && e.relatedTarget && !this.dom.el.contains(e.relatedTarget)) this.close();
    });
  }

  isOpen() {
    return this.dom.trigger.getAttribute('aria-expanded') === 'true';
  }

  open() {
    this.dom.trigger.setAttribute('aria-expanded', 'true');
    this.dom.list.hidden = false;
  }

  close() {
    this.dom.trigger.setAttribute('aria-expanded', 'false');
    this.dom.list.hidden = true;
  }
}

export default LanguageSwitcher;
